import styled from 'styled-components';

export const StyledSectionActionButtons = styled.div`
  display: flex;
  align-items: center;
`;
